'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @public
 */
var Quote = function Quote(props) {
  return _react2.default.createElement(
    Figure,
    null,
    _react2.default.createElement(
      BlockQuote,
      { className: props.className, cite: props.cite },
      props.children
    ),
    _react2.default.createElement(
      'figcaption',
      null,
      props.author
    )
  );
};

/**
 * @private
 */
var BlockQuote = _styledComponents2.default.blockquote.withConfig({
  displayName: 'quote__BlockQuote'
})(['margin:0;']);

/**
 * @private
 */
var Figure = _styledComponents2.default.figure.withConfig({
  displayName: 'quote__Figure'
})(['margin:0.5em;padding:0.5em 0.5em 0.5em 1em;border-left:0.5em solid var(--quote-border-color,currentColor);']);

/**
 * @private
 */
Quote.propTypes = {
  author: _propTypes2.default.string,
  cite: _propTypes2.default.string,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired

  /**
   * @private
   */
};Quote.defaultProps = {
  author: '',
  cite: '',
  className: ''

  /**
   * @private
   */
};Quote.displayName = 'Quote';

exports.default = Quote;
//# sourceMappingURL=index.js.map